<template>
  <sfs-form-modal
    :id="modalId"
    title="Add an Item"
    @on-hide="resetFormData"
  >
    <invoice-item-form
      @on-submit="createItem"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
      :client_id="client_id"
    />
  </sfs-form-modal>
</template>

<script>
import InvoiceItemForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'InvoiceItemAddModal',
  mixins: [formModalMixin],
  components: {
    InvoiceItemForm,
  },
  props: {
    invoice_id: Number,
    client_id: [String, Number],
  },
  data() {
    return {
      modalId: 'invoice-item-add-modal',
    };
  },
  methods: {
    createItem(data, handleCreate) {
      handleCreate(this.$invoicesAPI.createItem(this.invoice_id, data));
    },
    onSave() {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save');
    },
  },
};
</script>
